import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { ShipmentOrderStatus } from "../../../Generic/ShipmentOrders/Badge";

export const BookingOrderStatusBadge = styled(ShipmentOrderStatus)(() => ({
  justifyContent: "flex-start",
}));

export const BookingOrderReferenceRow = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "15px",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  tooltipTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    whiteSpace: "nowrap",
  },
  tooltipContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
}));

export default styles;
